// Include vertical slider
const BackgroundImage = require('./components/background-image');
const Woocommerce = require('./components/woocommerce');
BackgroundImage.init();
Woocommerce.init();

// Include modal functionality
// const Modal = require('./components/modal');
// Modal.init();

// // Example modal call
// document.addEventListener('DOMContentLoaded', function() {
// 	Modal.fill('Test title', '<u>Test body text<br/>...</b>');
// 	Modal.show();
// });

/**
 * On content loaded
 */
document.addEventListener('DOMContentLoaded', function () {
	const Navigation = require('./components/navigation');
	Navigation.init();

	// Add smooth scrolling when clicking any anchor link
	document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
		anchor.addEventListener('click', function (evt) {
			evt.preventDefault();
			var href = this.getAttribute('href');
			if (href && href != '#') {
				document.querySelector(href).scrollIntoView({
					behavior: 'smooth',
				});
			}
		});
	});

	// On page scroll show/hide the navbar actions and the scroll to top button
	var navbar = document.getElementById('navbar'),
		body = document.body,
		btn = document.getElementById('scrollToTop'),
		lastScrollTop = 0;
	window.onscroll = function () {
		var st = document.documentElement.scrollTop || document.body.scrollTop;
		// Show/hide the scroll to top button
		if (btn) {
			if (st > 450) {
				btn.classList.add('d-flex');
				btn.classList.remove('d-none');
			} else {
				btn.classList.remove('d-flex');
				btn.classList.add('d-none');
			}
		}

		// Show/hide the navbar
		if (navbar) {
			// Add / remove transparency
			if (st < 15) {
				navbar.classList.remove('active');
			} else {
				navbar.classList.add('active');
			}

			// Check if the scroll top bigger than x
			// if (st < 450) {
			// 	navbar.classList.remove('hide');
			// 	navbar.classList.add('show');
			// } else {
			// 	// Check the scroll direction
			// 	if (st > lastScrollTop) {
			// 		// Down scroll
			// 		navbar.classList.remove('show');
			// 		navbar.classList.add('hide');
			// 	} else {
			// 		// Upscroll
			// 		navbar.classList.remove('hide');
			// 		navbar.classList.add('show');
			// 	}

			// 	// For Mobile or negative scrolling
			// 	lastScrollTop = st <= 0 ? 0 : st;
			// }
		}
	};
	// Scroll to top function
	var scrollToTop = document.getElementById('scrollToTop');
	if (scrollToTop) {
		scrollToTop.addEventListener('click', function (evt) {
			evt.preventDefault();

			// Animated scroll
			scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		});
	}

	// Show/hide the password
	pwds = document.querySelectorAll('.js-show-hide');
	if (pwds && pwds.length) {
		pwds.forEach((pwd) => {
			pwd.addEventListener('click', function () {
				var input = this.parentNode.querySelector('input');
				if (input) {
					var type = input.getAttribute('type');
					input.setAttribute('type', type == 'password' ? 'text' : 'password');
				}
			});
		});
	}
});
